interface SpoorwebAutocompleteItemProps {
    meldingtekst: string;
    spoorwebNr: string;
    TIS?: string;
    timeSinceEvent?: string;
}

export function OngewensteGebeurtenisOptionLabel({
    meldingtekst,
    spoorwebNr,
    TIS,
    timeSinceEvent,
}: Readonly<SpoorwebAutocompleteItemProps>) {
    return (
        <div>
            <div className="mb-0.5">{meldingtekst}</div>
            <div className="flex gap-4 text-xs">
                <span>#{spoorwebNr}</span>
                <span>TIS {TIS}</span>
                <span className="italic">{timeSinceEvent}</span>
            </div>
        </div>
    );
}
